import { render, staticRenderFns } from "./editVideoPage.vue?vue&type=template&id=610e88c6&"
import script from "./editVideoPage.vue?vue&type=script&lang=js&"
export * from "./editVideoPage.vue?vue&type=script&lang=js&"
import style0 from "./editVideoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports